var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-grid-view"},_vm._l((_vm.items),function(item,index){return _c('grid-item',{key:index,attrs:{"item":item,"object-path":item.objectPath}})}))}
var staticRenderFns = []

export { render, staticRenderFns }